import styled from 'styled-components';

export const SocialShareButton = styled.button<{ color?: string; scale?: number }>`
  transform: ${({ scale }) => `scale(${scale})`};
  & .hover {
    transition: 0.2s ease-in-out;
  }
  &:hover .hover {
    fill: ${({ color }) => color};
  }
`;
